export const ACCEPTED_FILE_TYPES = "image/*, audio/mp3, video/mp4, .xlsx, .xls, .pdf, .doc, .docx, .csv, text/plain, .mov, .wav";
export const DATE_FORMAT = 'YYYY-MM-DD'; // Important: There should not be a reason to change this value.
export const PIN_LENGTH = 5;
export const MAX_RETRY_COUNT = 3;
export const MAX_VERIFY_WITH_NAME_RETRY_COUNT = 5;
export const UPDOX_TAGLINE = 'Updox: Simplifying the business of health care';
export const MESSAGE_POLL_INTERVAL = 10000; // Polling for new messages in a specific conversation
export const CONVERSATION_POLL_INTERVAL = 20000; // Polling for all conversations in conversation menu
export const DEFAULT_ATTACHMENT_URL = '/';
export const LIMITED_LOGIN_SEND_MESSAGE_TIMER_LENGTH = 600;
export const SAVE_PIN_COPY = 'Please create a five-digit PIN number. This PIN number will be used to validate your identity for secure communication going forward.';
export const DEFAULT_HIPAA_SAFE_LABEL = "medical provider";